import {locationFields, locationTuple, mergeResumeLocation} from "./CandidateLocationMerge.js";

export const mapParsedResumeToCandidateApplicationFormStore = (data, parseResumeStore, candidateApplicationFormStore, candidateProfileStore, ignoreContactInfo =false) => {

  const username = generateUsername(data.firstName, data.lastName);
  const mergedLocation = parseResumeStore.locationManuallyEdited ? locationTuple(data) : mergeResumeLocation(candidateApplicationFormStore.newUserDetails, data);
  const location = generateCityStateCombo(mergedLocation.city, mergedLocation.state);

  Object.assign(candidateApplicationFormStore.newUserDetails, {
    ...ignoreContactInfo && {
      ...data.firstName && {firstName: data.firstName},
      ...data.lastName && {lastName: data.lastName},
      ...data.email && {email: data.email},
      ...data.phone && {phone: data.phone},
      ...mergedLocation,
      ...location && {location: location},
    },
    ...username && {username: username},
    ...{tosChecked: true},
  });

  Object.assign(candidateApplicationFormStore.state, {
    ...data.education && {education: data.education},
    ...data.careerPassport && {careerPassport: data.careerPassport},
    ...data.careerPassport?.length && {noPreviousWorkExperience: false},
    ...data.exceptionalAbility && {exceptionalAbility: data.exceptionalAbility},
  });

  if (!candidateApplicationFormStore.applicationForm.candidate) candidateApplicationFormStore.applicationForm.candidate = {};

  Object.assign(candidateApplicationFormStore.applicationForm.candidate, {
    ...data.education && {education: data.education},
    ...data.careerPassport && {careerPassport: data.careerPassport},
    ...data.careerPassport?.length && {noPreviousWorkExperience: false},
    ...data.exceptionalAbility && {exceptionalAbility: data.exceptionalAbility},
  });

  mapParsedResumeToCandidateProfileStore(data, parseResumeStore, candidateProfileStore);
};

export const mapParsedResumeToCandidateProfileStore = (data, parseResumeStore, candidateProfileStore) => {
  const before = locationTuple(candidateProfileStore.state);
  const {uuid, locationExpectedRevision} = parseResumeStore.resume;
  let mergedLocation = before;
  if (parseResumeStore.locationManuallyEdited) {
    mergedLocation = locationTuple(data);
  } else if (uuid && Number.isInteger(locationExpectedRevision) && locationExpectedRevision >= 0) {
    mergedLocation = mergeResumeLocation(candidateProfileStore.state, data);
  }
  const otherDetails = Object.fromEntries(Object.entries(data).filter(([key]) => ![...locationFields, "location", "locationRevision", "locationExpectedRevision"].includes(key)));
  Object.assign(candidateProfileStore.state, otherDetails, mergedLocation, {
    location: generateCityStateCombo(mergedLocation.city, mergedLocation.state),
    resumeUuid: parseResumeStore.resume.uuid,
  });
  if (parseResumeStore.locationManuallyEdited) {
    candidateProfileStore.clearResumeLocationContext?.();
  } else if (JSON.stringify(before) !== JSON.stringify(mergedLocation)) {
    candidateProfileStore.setResumeLocationContext?.(parseResumeStore.resume.uuid, parseResumeStore.resume.locationExpectedRevision);
  }
  if (candidateProfileStore.state.careerPassport?.length) candidateProfileStore.state.noPreviousWorkExperience = false;
};


const generateUsername = (firstName = "", lastName= "") => {
  if (!firstName && !lastName) return "";
  const firstNameCleaned = firstName.replace(/[^a-zA-Z0-9]/g, "");
  const lastNameCleaned = lastName.replace(/[^a-zA-Z0-9]/g, "");
  const randomNumber = Math.floor(Math.random() * 10000);

  if (!firstNameCleaned && !lastNameCleaned) return "";
  if (!firstNameCleaned) return lastNameCleaned.toLowerCase();
  if (!lastNameCleaned) return firstNameCleaned.toLowerCase();

  return `${firstNameCleaned}.${lastNameCleaned}`.toLowerCase() + randomNumber;
};

const generateCityStateCombo = (city, state) => {
  if (!city && !state) return "";
  if (!city) return state;
  if (!state) return city;
  return `${city}, ${state}`;
};
